import { PayloadAction } from "@reduxjs/toolkit";
import { put, all, takeLatest, takeEvery, call } from "redux-saga/effects";
import { GestaoEntrega, LocalizacaoMotorista } from "./types";
import { cargaActions } from "../carga/reducer";
import { AxiosResponse } from "axios";
import { apiCall } from "../../utils/apiCall";
import { formatError } from "../../utils/formatError";
import { entregaActions } from "./reducer";
import { Carga } from "../carga/types";

type IRequestEnviarGestaoResponse = {
  message: string;
}

function* registraNovoGestaoEntregaWorker({ payload }: PayloadAction<{ gestao: GestaoEntrega; carga: Carga }>) {
  if (payload.gestao.e_tentativa_entrega == 1) {
    yield put(cargaActions.marcaNotaDaCargaReentrega(payload.gestao));
    return;
  };

  yield put(cargaActions.retiraNotaDaCarga(payload.gestao));
}

function* registraNovoGestaoEntregaGrupoWorker({ payload }: PayloadAction<{ gestoes: GestaoEntrega[]; carga: Carga }>) {
  for (const gestao of payload.gestoes) {
    if (gestao.e_tentativa_entrega == 1) {
      yield put(cargaActions.marcaNotaDaCargaReentrega(gestao));
      continue;
    }

    yield put(cargaActions.retiraNotaDaCarga(gestao));
  }
}

// Envios em andamento, em memória (não persistido). O reenvio dos pendentes dispara a cada troca de tela;
// sem esta trava, a mesma nota subiria várias vezes em paralelo enquanto as fotos ainda estão sendo enviadas.
const enviosEmAndamento = new Set<string>();

export const chaveDoEnvio = (gestao: GestaoEntrega) =>
  `${gestao.j81_ukeyp}|${gestao.e_tentativa_entrega}|${gestao.data_entrega}`;

export const envioEstaEmAndamento = (gestao: GestaoEntrega) => enviosEmAndamento.has(chaveDoEnvio(gestao));

export function* requestEnviaGestaoEntregaWorker({ payload }: PayloadAction<GestaoEntrega>) {
  const chave = chaveDoEnvio(payload);

  if (enviosEmAndamento.has(chave)) {
    return;
  }

  enviosEmAndamento.add(chave);

  try {
    const res: AxiosResponse<IRequestEnviarGestaoResponse> = yield call(apiCall, {
      url: `/gestao-de-entrega/v2/enviar`,
      method: "post",
      data: payload,
    });
    if (res.data.message) {
      yield put(entregaActions.setSuccess(res.data.message));
    }
    yield put(entregaActions.retiraGestaoPendente(payload.j81_ukeyp));
  } catch (error) {
    yield put(
      entregaActions.setError(formatError(error))
    );
  } finally {
    enviosEmAndamento.delete(chave);
  }
}

function* requestEnviaLocalizacaoMotoristaWorker({ payload }: PayloadAction<LocalizacaoMotorista>) {
  try {
    yield call(apiCall, {
      url: `/gestao-de-entrega/v2/localizacao`,
      method: "post",
      data: payload,
    });
  } catch (error) {
    console.log(error);
  }
}

export function* entregaSaga() {
  yield all([
    takeLatest("entrega/registraNovoGestaoEntrega", registraNovoGestaoEntregaWorker),
    takeLatest("entrega/registraNovoGestaoEntregaGrupo", registraNovoGestaoEntregaGrupoWorker),
    // Vários pendentes são disparados em sequência ao voltar o sinal; takeLatest cancelaria todos menos o último.
    takeEvery("entrega/requestEnviaGestaoEntrega", requestEnviaGestaoEntregaWorker),
    takeLatest("entrega/requestEnviaLocalizacaoMotorista", requestEnviaLocalizacaoMotoristaWorker),
  ]);
}
